import React from 'react';
import { Badge } from '@/components/ui/badge';
import { cn } from '@/lib/utils';
import { OverflowBadge } from '../OverflowBadge';

export interface BadgeItem {
  text: string;
  background_color?: string;
  text_color?: string;
}

export interface BadgeWithCounterProps {
  items: BadgeItem[] | null | undefined;
  className?: string;
}

const StyledBadge = ({ item, truncate = false }: { item: BadgeItem; truncate?: boolean }) => {
  const hasCustomColors = item.background_color || item.text_color;

  return (
    <Badge
      variant="secondary"
      style={{
        ...(item.background_color && { backgroundColor: item.background_color }),
        ...(item.text_color && { color: item.text_color }),
      }}
      className={cn(truncate && 'max-w-[150px]', hasCustomColors && 'border-transparent')}
      title={truncate ? item.text : undefined}
    >
      <span className={cn(truncate && 'block overflow-hidden text-ellipsis whitespace-nowrap')}>
        {item.text}
      </span>
    </Badge>
  );
};

export const BadgeWithCounter = ({ items, className }: BadgeWithCounterProps) => {
  if (!items || items.length === 0) {
    return null;
  }

  const [firstItem, ...restItems] = items;

  return (
    <div className={cn('flex items-center gap-1', className)}>
      <StyledBadge item={firstItem} truncate />

      <OverflowBadge
        count={restItems.length}
        tooltipContent={
          <div className="flex flex-col gap-1">
            {restItems.map((item, index) => (
              <span key={index}>{item.text}</span>
            ))}
          </div>
        }
        style={{
          ...(firstItem.background_color && { backgroundColor: firstItem.background_color }),
          ...(firstItem.text_color && { color: firstItem.text_color }),
        }}
      />
    </div>
  );
};
